import PaginationBoxView from './pagination-box-view';

export default PaginationBoxView;